import { noopAnalyticsTracker } from './types';
import { createFirebaseAnalyticsTracker } from './firebase-analytics-tracker';
export type { AnalyticsParams, AnalyticsTracker } from './types';

const isFirebaseConfigured = !!(
  import.meta.env.VITE_FIREBASE_API_KEY &&
  import.meta.env.VITE_FIREBASE_PROJECT_ID &&
  import.meta.env.VITE_FIREBASE_APP_ID
);

export const appAnalytics = isFirebaseConfigured
  ? createFirebaseAnalyticsTracker()
  : noopAnalyticsTracker;

export const trackPageView = (
  pageName: string,
  params?: Record<string, unknown>,
): void => {
  appAnalytics.track('page_view', {
    page_name: pageName,
    page_path: window.location.pathname,
    page_location: window.location.href,
    ...params,
  });
};
